module.exports = __webpack_public_path__ + "media/images/svg/admin/man-3f107deb0a50eb1f1a5d907b4c5520f7.svg";